import React from 'react'

interface Props {}

const LandingPageStandardGeneral: React.FunctionComponent<Props> = () => {
  return <>LandingPageStandardGeneral</>
}

export default LandingPageStandardGeneral
